<template>
  <section id="cartFinalize">
    <div id="shoppingPO">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-8 offset-xl-4 col-lg-8 offset-lg-4 col-12 offset-0"
          >
            <div class="sp-content text-md-right">
              Shopping with PO Number:
              <span class="sp-number">{{ poNumber }}</span>
              <!-- <a href="#" class="sp-number-edit">Edit PO Number</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="finalizeTop">
      <div class="container">
        <div class="container">
          <div class="row mb-5">
            <div class="col-lg-9 mb-4 mb-lg-0">
              <h1>Review & Finalize Order</h1>
            </div>
            <div class="col-lg-3">
              <a href="/cart" class="btn btn-dark">Back to Cart</a>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="alert alert-secondary">
                <h4>
                  Please verify your information below and contact customer
                  service for any changes.
                </h4>
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="row">
                <div class="col-12">
                  <h2>Customer Information:</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="customer-info">
                    <div class="row">
                      <div class="col-12">
                        <div class="ci-heading" v-if="billingCompanyName">
                          {{ billingCompanyName }}
                        </div>
                        <div class="ci-heading" v-else>{{ companyName }}</div>
                      </div>
                      <div class="col-12">
                        <div class="ci-info">
                          <p>{{ billingStreet }}</p>
                          <p>{{ billingStreet2 }}</p>
                          <p>
                            {{ billingCity }}, {{ billingState }}
                            {{ billingPostalCode }}
                          </p>
                          <p>{{ firstName }} {{ lastName }}</p>
                          <p>{{ phone }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="row">
                <div class="col-12">
                  <h2>Ship To:</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="customer-info">
                    <div class="row">
                      <div class="col-12">
                        <div class="ci-heading">{{ shippingCompanyName }}</div>
                      </div>
                      <div class="col-12">
                        <div class="ci-info">
                          <p>{{ shippingStreet }}</p>
                          <p>{{ shippingStreet2 }}</p>
                          <p>
                            {{ shippingCity }}, {{ shippingState }}
                            {{ shippingPostalCode }}
                          </p>
                          <p>{{ firstName }} {{ lastName }}</p>
                          <p>{{ phone }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="row">
                <div class="col-12">
                  <h2>Special Instructions:</h2>
                </div>
              </div>
              <p>{{ SpecialInstructions }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-form id="assemblyForm" @submit.prevent>
      <div class="POOrders mb-5" v-for="order in orders" :key="order.id">
        <!-- If no PO Number for Quotes, Show this -->
        <div class="enterPO" v-if="!order.number">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-2">
                <label for="PONumber">Enter PO Number*</label>
              </div>
              <div class="col-lg-4">
                <input type="text" v-model="order.number" name="PONumber" />
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <!-- If PO Number for Quotes/Order, Show this -->
          <div class="row mb-3">
            <div class="col-8">
              <div class="ponumber">PO NUMBER: {{ order.number }}</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <div class="assemblyName">{{ order.machine.description }}</div>
              <div class="assemblyDescription">{{ order.assembly.name }}</div>
            </div>
          </div>
          <b-table
            stacked="lg"
            :fields="partsFields"
            :items="order.parts"
            responsive="sm"
          >
            <!-- A virtual column -->
            <template v-slot:cell(item)="data">
              <div class="nowrap">
                {{ data.item.part.item }}
              </div>
            </template>

            <!-- A custom formatted column -->
            <template v-slot:cell(code)="data">
              <div class="nowrap">
                {{ data.item.part.code }}
              </div>
            </template>

            <!-- A virtual composite column -->
            <template v-slot:cell(description)="data">
              {{ data.item.part.description }}
            </template>

            <!-- Optional default data cell scoped slot -->
            <template v-slot:cell(qty)="data">
              {{ data.item.part.quantityPerMachine }}
            </template>

            <template v-slot:cell(price)="data">
              {{ data.item.part.price | currency }}
            </template>

            <template v-slot:cell(cartqty)="data">
              <input
                type="text"
                v-model="data.item.quantity"
                class="table-input"
                disabled
              />
            </template>

            <template v-slot:cell(cost)="data">
              {{ data.item.cost | currency }}
            </template>

            <template v-slot:cell(remove)="data"> </template>
          </b-table>

          <div class="form-btns">
            <div class="row">
              <div class="col-lg-8 offset-lg-4">
                <div class="row">
                  <div class="col-lg-8 mb-4 text-right pr-lg-0">
                    <div class="subtotal-label">
                      Subtotal for PO Number: {{ order.number }}
                    </div>
                  </div>
                  <div class="col-lg-4 mb-4 pl-lg-0">
                    <div class="subtotal-price">
                      {{ order.cost | currency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- If no PO Number for Quotes, Show this -->

      <div id="bottomTotals" class="mt-5">
        <div class="container">
          <div id="orderTotal" class="row align-items-center">
            <div class="col-lg-7 pl-lg-0">
              <div class="order-total">
                Total for all orders: {{ total | currency }}
              </div>
              <!-- <p>
                All web orders have a standard 2 week lead time, but may be shipped sooner. 
              </p> -->
            </div>
            <div class="col-lg-5 pr-lg-0">
              <div class="row">
                <div class="col-lg-6 mb-4 mb-lg-0">
                  <a @click="saveQuote()" class="btn btn-outline"
                    >Save as Quote</a
                  >
                </div>

                <div class="col-lg-6">
                  <a @click="finalizeOrder()" class="btn btn-primary mb-4"
                    >finalize order</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="cart-reset-container">
                <b-button @click="showDeleteModal" class="cart-reset"
                  >Would you like to reset your cart?</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </section>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

import Vue from "vue";
import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);

export default {
  name: "Cart",
  computed: {},
  mounted() {
    if (localStorage.cartId) {
      this.cartId = localStorage.cartId;

      this.fullOrder = this.$route.params.fullOrder;
      this.purchaseOrders = this.$route.params.purchaseOrders;
      this.SpecialInstructions = this.$route.params.SpecialInstructions;
      this.companyId = this.$route.params.companyId;
    }

    this.saveCart();
    // this.getShipping();
    // this.getCompanies();
  },
  data() {
    return {
      cartId: "",
      orders: [],
      poNumber: localStorage.poNumber,
      companyName: "",
      purchaseOrders: [],
      companyId: [],
      SpecialInstructions: "",
      fullOrder: [],
      billingCompanyName: "",
      billingStreet: "",
      billingStreet2: "",
      billingCity: "",
      billingState: "",
      billingPostalCode: "",
      shippingCompanyName: "",
      shippingStreet: "",
      shippingStreet2: "",
      shippingCity: "",
      shippingState: "",
      shippingPostalCode: "",
      firstName: "",
      lastName: "",
      phone: "",
      total: 0,
      location: "",
      locations: [],
      partsFields: [
        "item",
        "code",
        "description",
        { key: "qty", label: "QTY PER MACHINE" },
        "price",
        { key: "cartqty", label: "Cart Qty" },
        "cost",
        { key: "remove", label: "" },
      ],
      partsList: [
        {
          _cellVariants: { cartqty: "input-td" },
          item: "8ZEW",
          code: "NDB S 1550 HS",
          description: "Point Auger, Ext. Wear, (HCV-8) Ht. Treat & Slick",
          qty: 2,
          price: "$2,178.00",
          cartqty: 2,
          cost: "$4356.00",
        },
        {
          _cellVariants: { cartqty: "input-td" },
          item: "8ZEW",
          code: "NDB S 1550 HS",
          description: "Point Auger, Ext. Wear, (HCV-8) Ht. Treat & Slick",
          qty: 2,
          price: "$2,178.00",
          cartqty: 2,
          cost: "$4356.00",
        },
      ],
      clear: "",
    };
  },
  methods: {
    saveCart() {
      apiService
        .saveCart({
          id: this.cartId || 0,
          purchaseOrders: this.fullOrder.purchaseOrders,
          companyId: this.$route.params.companyId,
          specialInstructions: this.SpecialInstructions,
        })
        .then((request) => {
          this.saveCartSuccessful(request);
          localStorage.cartId = this.cartId;
        })
        .catch((err) => this.saveCartFailed(err));
    },
    saveCartSuccessful(request) {
      (this.cartId = request.id),
        (this.orders = request.purchaseOrders),
        (this.companyName = request.company.name),
        (this.billingCompanyName = request.company.plant.name),
        (this.billingStreet = request.company.plant.street),
        (this.billingStreet2 = request.company.plant.street2),
        (this.billingCity = request.company.plant.city),
        (this.billingState = request.company.plant.state),
        (this.billingPostalCode = request.company.plant.postalCode),
        (this.shippingCompanyName = request.company.shipTo.name),
        (this.shippingStreet = request.company.shipTo.street),
        (this.shippingStreet2 = request.company.shipTo.street2),
        (this.shippingCity = request.company.shipTo.city),
        (this.shippingState = request.company.shipTo.state),
        (this.shippingPostalCode = request.company.shipTo.postalCode),
        (this.firstName = request.user.firstName),
        (this.lastName = request.user.lastName),
        (this.phone = request.user.phoneNumber),
        (this.total = request.cost),
        (this.fullOrder = request);
    },
    saveCartFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    removeItem(item, order) {
      var removeIndex = "";

      order.parts.forEach(() => {
        removeIndex = order.parts
          .map(function(item) {
            return item.partItem;
          })
          .indexOf(item.partItem);
      });

      order.parts.splice(removeIndex, 1);
      this.$forceUpdate();
    },
    updateSubtotal(order) {
      var subtotal = 0;

      if (order.parts.length) {
        for (var i in order.parts) {
          subtotal = subtotal + order.parts[i].cost;
        }
        order.cost = subtotal;

        this.$forceUpdate(order);
      } else {
        order.cost = 0;
        this.total = 0;
        this.$forceUpdate();
      }

      this.getTotal();
    },
    getTotal() {
      var total = 0;
      this.orders.forEach((order) => {
        total = total + order.cost;
      });

      this.total = total;
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm("PLEASE CONFIRM YOU WANT TO DELETE ALL ITEMS IN CART", {
          title: "PLEASE CONFIRM",
          id: "deleteModal",
          size: "md",
          buttonSize: "sm",
          okVariant: "dark",
          okTitle: "Yes, please clear cart",
          cancelVariant: "outline",
          cancelTitle: "No, please don’t",
          hideHeaderClose: true,
          centered: true,
        })
        .then((clear) => {
          if (clear) {
            apiService
              .deleteCart({
                id: this.cartId,
              })
              .then((request) => {
                this.deleteCartSuccessful(request);
              })
              .catch((err) => this.deleteCartFailed(err));
          }
        })
        .catch((err) => this.deleteCartFailed(err));
    },
    deleteCartSuccessful() {
      localStorage.cartId = 0;

      delete localStorage.poNumber;
      delete localStorage.companyId;
      delete localStorage.machineId;
      delete localStorage.assemblyId;

      this.$router.push({
        name: "Create New Order",
      });
    },
    deleteCartFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    finalizeOrder() {
      this.$router.push({
        name: "Cart Success",
        params: {
          id: this.cartId,
          order: this.fullOrder,
          companyId: this.companyId,
          fullOrder: this.fullOrder,
          SpecialInstructions: this.SpecialInstructions,
        },
      });
    },
    saveQuote() {
      // console.log(this.companyId);

      this.$router.push({
        name: "Quote Saved Items",
        params: {
          id: this.cartId,
          order: this.fullOrder,
          purchaseOrders: this.fullOrder.purchaseOrders,
          companyId: this.companyId,
          fullOrder: this.fullOrder,
          SpecialInstructions: this.SpecialInstructions,
          CreateQuote: true,
        },
      });
    },
  },
};
</script>
